<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">


      <login-card v-show="layout.showSMSDialog" class="pt-4">
        <p slot="description" class="description mt-4">{{ $t('pages.forgot.descriptionsms') }}</p>
        <md-field slot="inputs" class="label-floating">
          <md-input v-model="phone" type="phone" class="form-control"></md-input>
          <label class="control-label">{{ $t('labels.phone') }}</label>
        </md-field>
        <template slot="footer">
          <div class="flex-column">
            <md-button v-show="!layout.working" v-on:click="sendSMS" class="md-success md-lg">
              {{ $t('buttons.resetpassword') }}
            </md-button>
            <md-button v-show="!layout.working" v-on:click="login" class="md-black md-lg md-simple">
              <md-icon>keyboard_arrow_left</md-icon>
              {{ $t('buttons.back') }}
            </md-button>
          </div>
        </template>
        <md-button v-show="layout.working" slot="footer" class="md-simple md-success md-lg">
          <md-progress-spinner :md-diameter="30" md-mode="indeterminate" class="md-accent"></md-progress-spinner>
          {{ $t('pages.forgot.resetting') }}
        </md-button>
      </login-card>


      <login-card v-show="layout.showConfirmationSMS" class="pt-4">
        <p slot="description" v-html="$t('pages.forgot.confirmation.descriptionsms')"></p>
        <template slot="footer">
          <div class="flex-column">
            <md-button v-show="!layout.working" v-on:click="login" class="md-simple md-black md-lg">
              <md-icon>keyboard_arrow_left</md-icon>
              {{ $t('buttons.back') }}
            </md-button>
          </div>
        </template>
      </login-card>
      
      <login-card v-show="layout.showConfirmation" class="pt-4">
        <p slot="description" v-html="$t('pages.forgot.confirmation.description')"></p>
        <template slot="footer">
          <div class="flex-column">
            <md-button v-show="!layout.working" v-on:click="login" class="md-simple md-black md-lg">
              <md-icon>keyboard_arrow_left</md-icon>
              {{ $t('buttons.back') }}
            </md-button>
            <md-button v-show="!layout.working" v-on:click="showSMSForm" class="md-simple md-black md-lg">
              <md-icon>phone_android</md-icon>
              {{ $t('buttons.showsmsform') }}
            </md-button>
          </div>
        </template>
      </login-card>

      <login-card header-color="yellow" v-show="layout.showEmailForm" class="pt-4">
        <p slot="description" class="description mt-4">{{ $t('pages.forgot.description') }}</p>
        <md-field slot="inputs" class="label-floating">
          <md-input v-model="email" type="email" class="form-control"></md-input>
          <label class="control-label">{{ $t('labels.email') }}</label>
        </md-field>

        <template slot="footer">
          <div class="flex-column">
            <md-button v-show="!layout.working" v-on:click="sendEmail" class="md-success md-lg">
              {{ $t('buttons.resetpassword') }}
            </md-button>
            <md-button v-show="!layout.working" v-on:click="login" class="md-black md-lg md-simple">
              <md-icon>keyboard_arrow_left</md-icon>
              {{ $t('buttons.back') }}
            </md-button>
          </div>
        </template>
        <md-button v-show="layout.working" slot="footer" class="md-simple md-success md-lg">
          <md-progress-spinner :md-diameter="30" md-mode="indeterminate" class="md-accent"></md-progress-spinner>
          {{ $t('pages.forgot.resetting') }}
        </md-button>
      </login-card>


    </div>
  </div>
</template>
<script>
import {LoginCard} from "@/components";
import store from "../../../store"
import apiService from "../../../services/APIService"

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      layout: {
        working: false,
        showEmailForm: true,
        showConfirmation: false,
        showConfirmationSMS: false,
        showSMSDialog: false
      },
      email: '',
      phone: ''
    };
  },
  methods: {
    showSMSForm() {
      this.layout.showSMSDialog = true;
      this.layout.showConfirmation = false;
    },
    sendEmail() {
      if (this.email === '')
        return;
      this.layout.working = true;
      apiService.postApi(`/auth/v1/user/password`, {Email: this.email}).then(() => {
        this.layout.working = false;
        this.layout.showEmailForm = false;
        this.layout.showConfirmation = true;


      }).catch(error => {
        this.layout.working = false;
        alert("FEJL!\n(" + error.response.status + " " + error.response.statusText + ")\n\nEmail ukendt.");

      });
    },
    sendSMS() {
      
      
      if (this.phone === '')
        return;
        
      this.layout.working = true;
      apiService.postApi(`/auth/v1/user/password`, {Email: this.email, Phone : this.phone}).then(() => {
        this.layout.working = false;
        this.layout.showSMSDialog = false;
        this.layout.showConfirmationSMS = true;


      }).catch(error => {
        this.layout.working = false;
        alert("FEJL!\n(" + error.response.status + " " + error.response.statusText + ")\n\nEmail ukendt.");

      });
    },
    login() {

      this.$router.push({name: "Login"});
    }
  }
};
</script>

<style lang="scss" scoped>
.md-progress-spinner {
  margin: 15px;
}
</style>
